
import { Options, Vue } from 'vue-class-component'
import { mapState } from 'vuex'
import ShareBtn from '@/components/ShareBtn.vue'

@Options({
    components: { ShareBtn },
    computed: {
        ...mapState(['loginInfo', 'aid']),
    },
    data() {
        return {
            hasApply: false,
            form: {
                name: '',
                phone: '',
                unit: '',
                desc: '',
                address: '',
            },
            formItems: [{
                title: '姓名',
                key: 'name',
                required: true,
                type: 'text',
                style: 'letter-spacing: 2em;'
            },{
                title: '联系方式',
                key: 'phone',
                required: true,
                type: 'text',
                pattern: /^(?:(?:\+|00)86)?1[3-9]\d{9}$/,
                maxLength: 11,
            },{
                title: '所在单位或高校',
                key: 'unit',
                required: true,
                type: 'text',
            },{
                title: '个人简介',
                key: 'desc',
                required: true,
                type: 'textarea',
                maxLength: 500,
                placeholder: ''
            },{
                title: '联系地址',
                key: 'address',
                required: false,
                type: 'text',
            }]
        }
    },
    methods: {
        submitConfirm() {
            const isPass = this.validateForm()
            if(!isPass) return 

            this.$common.pageLoading(true)
            this.setApplyInfo()
            .then((res: any) => {
                this.$common.pageLoaded()
                this.$common.toast('报名成功')
                setTimeout(() => {
                    this.$router.push('/')
                }, 1000)
            })
            .catch((err: any) => {
                this.$common.pageLoaded()
                this.$common.toast(err && err.errmsg || '报名失败')
            })
        },
        validateForm() {
            for(let i = 0; i< this.formItems.length; i++ ) {
                const v = this.formItems[i];
                if(v.required && !this.form[v.key]) {
                    this.$common.toast(`请填写${v.title}`)
                    return false
                }
                if(v.required && v.pattern && !v.pattern.test(this.form[v.key])) {
                    this.$common.toast(`请填写正确的${v.title}`)
                    return false
                }
            }
            return true
        },
        setApplyInfo() {
            return this.$request('/temporary/xmtjnds', {
                aid: this.aid,
                phone: this.loginInfo.phone,
                info: this.form
            }, 'put')
        },
        getApplyInfo() {
            this.$request(
                '/temporary/xmtjnds', 
                {
                    aid: this.aid,
                    phone: this.loginInfo.phone,
                }, 
                'get',
            ).then((data: any) => {
                if(data && data.phone) {
                    this.form = { ...data }
                    this.hasApply = true
                }
            }).catch((err: any) => {
                if (err && err.errno == 1001) {
                    this.$common.toast('请先登录')
                    this.$router.replace('/login')
                }
            })
        },
    },
    mounted () {
        this.$common.pageLoaded()
        this.$common.track('load', '进入报名页')

        this.getApplyInfo()
    }
})
export default class Apply extends Vue {}
